function setcloneHeader() {
    var body = document.body;
    var header = document.getElementById('header');

    if (!header) return;

    var cloneHeader = header.cloneNode(true);
    cloneHeader.id = 'js-clone-header';
    cloneHeader.classList.add('clone-header');

    body.insertBefore(cloneHeader, body.firstChild);
}
setcloneHeader();

//検索表示・非表示
const $navs = document.getElementsByClassName('headerNav');
const $searchAreas = document.getElementsByClassName('searchArea');
const $openBtns = document.getElementsByClassName('openSearch');
const $closeBtns = document.getElementsByClassName('closeSearch');

//表示
for (var $i = 0; $i < $openBtns.length; $i++) {
    $openBtns[$i].onclick = function () {
        console.log('yeah');
        for (var $j = 0; $j < $searchAreas.length; $j++) {
            $searchAreas[$j].classList.add('fadeIn');
            $searchAreas[$j].style.display = 'flex';
        }
        for (var $s = 0; $s < $navs.length; $s++) {
            $navs[$s].classList.add('fadeIn');
            $navs[$s].style.display = "none";
        }
    }
}

//非表示
for (var $i = 0; $i < $closeBtns.length; $i++) {
    $closeBtns[$i].onclick = function () {
        for (var $j = 0; $j < $searchAreas.length; $j++) {
            $searchAreas[$j].style.display = 'none';
        }
        for (var $s = 0; $s < $navs.length; $s++) {
            $navs[$s].style.display = "flex";
        }
    }
}

//ハンバーガーメニュー
const $hMENUs = document.getElementsByClassName('target');
const $line1s = document.getElementsByClassName('line1');
const $line2s = document.getElementsByClassName('line2');
const $line3s = document.getElementsByClassName('line3');
const $navFs = document.getElementsByClassName('nav_f');
function hamburger() {
    for (var $a = 0; $a < $line1s.length; $a++) {
        $line1s[$a].classList.toggle('linea');
    }
    for (var $b = 0; $b < $line2s.length; $b++) {
        $line2s[$b].classList.toggle('lineb');
    }
    for (var $c = 0; $c < $line3s.length; $c++) {
        $line3s[$c].classList.toggle('linec');
    }

    for (var $d = 0; $d < $navFs.length; $d++) {
        $navFs[$d].classList.toggle('fadeInH');
    }

}

for (var $k = 0; $k < $hMENUs.length; $k++) {
    $hMENUs[$k].onclick = function () {
        hamburger();
    }
}

/*
document.getElementsByClassName('target').addEventListener('click', function () {
  hamburger();
});
*/

let list = document.getElementsByClassName('list');

for (let i = 0; i < list.length; i++) {
    list[i].addEventListener('click', function () {
        hamburger();
    });
}
